import { QueueWaitOfferThresholdsBuilder, QueueWaitOfferOptionsBuilder, QueueWaitOfferBuilder } from '../..';
import { VoiceMessageBuilder } from '../../..';
var WaitOfferSettingsBuilder = /** @class */ (function () {
    function WaitOfferSettingsBuilder() {
        this.waitOfferSettings = {
            enabled: false,
            queueWaitOfferThresholds: new QueueWaitOfferThresholdsBuilder().build(),
            waitOfferMessage: new VoiceMessageBuilder().build(),
            waitOfferOptions: [new QueueWaitOfferBuilder().build()],
            // will be deprecated
            queueWaitOfferOptions: new QueueWaitOfferOptionsBuilder().build()
        };
    }
    WaitOfferSettingsBuilder.prototype.withEnabled = function (enabled) {
        this.waitOfferSettings.enabled = enabled;
        return this;
    };
    WaitOfferSettingsBuilder.prototype.withQueueWaitOfferThresholds = function (queueWaitOfferThresholds) {
        this.waitOfferSettings.queueWaitOfferThresholds = queueWaitOfferThresholds;
        return this;
    };
    WaitOfferSettingsBuilder.prototype.withQueueWaitOfferMessage = function (waitOfferMessage) {
        this.waitOfferSettings.waitOfferMessage = waitOfferMessage;
        return this;
    };
    WaitOfferSettingsBuilder.prototype.withQueueWaitOffer = function (waitOfferOptions) {
        this.waitOfferSettings.waitOfferOptions = waitOfferOptions;
        return this;
    };
    WaitOfferSettingsBuilder.prototype.build = function () {
        return this.waitOfferSettings;
    };
    return WaitOfferSettingsBuilder;
}());
export { WaitOfferSettingsBuilder };
//# sourceMappingURL=wait-offer-options.builder.js.map